import React, { memo, forwardRef } from "react";
const SvgBackwardReactionwithoverandunderscript = forwardRef(
  (props, svgRef) => {
    return (
      <svg
        width={32}
        height={32}
        fill="none"
        viewBox="0 0 32 32"
        ref={svgRef}
        {...props}
      >
        <rect
          width={8}
          height={10}
          fill="#DBDBDB"
          rx={1}
          transform="matrix(-1 0 0 1 20 3)"
        />
        <rect
          width={8}
          height={10}
          fill="#DBDBDB"
          rx={1}
          transform="matrix(-1 0 0 1 20 19)"
        />
        <path
          fill="#717171"
          fillRule="evenodd"
          d="M9.293 10.293a1 1 0 111.414 1.414L7.414 15H27a1 1 0 110 2H7.414l3.293 3.293a1 1 0 01-1.414 1.414l-5-5a1 1 0 010-1.414l5-5z"
          clipRule="evenodd"
        />
      </svg>
    );
  }
);
SvgBackwardReactionwithoverandunderscript.displayName =
  "SvgBackwardReactionwithoverandunderscript";
const MemoForwardRef = memo(SvgBackwardReactionwithoverandunderscript);
export default MemoForwardRef;
